"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[844],{

/***/ 5546:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/utils/units-converters/rem.mjs
var rem = __webpack_require__(38292);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/utils/get-size/get-size.mjs
var get_size = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/styles-api/create-vars-resolver/create-vars-resolver.mjs
var create_vars_resolver = __webpack_require__(79346);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/MantineProvider/use-props/use-props.mjs
var use_props = __webpack_require__(57285);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/styles-api/use-styles/use-styles.mjs + 17 modules
var use_styles = __webpack_require__(21413);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/Box/Box.mjs + 21 modules
var Box = __webpack_require__(46293);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/factory/polymorphic-factory.mjs
var polymorphic_factory = __webpack_require__(10046);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/MantineProvider/color-functions/get-theme-color/get-theme-color.mjs
var get_theme_color = __webpack_require__(57614);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/factory/factory.mjs
var factory = __webpack_require__(21774);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(84419);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Loader/Loader.module.css.mjs
'use client';
var classes = {"root":"m_5ae2e3c","barsLoader":"m_7a2bd4cd","bar":"m_870bb79","bars-loader-animation":"m_5d2b3b9d","dotsLoader":"m_4e3f22d7","dot":"m_870c4af","loader-dots-animation":"m_aac34a1","ovalLoader":"m_b34414df","oval-loader-animation":"m_f8e89c4b"};


//# sourceMappingURL=Loader.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Loader/loaders/Bars.mjs
'use client';













const Bars = (0,react.forwardRef)(({ className, ...others }, ref) => /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, { component: "span", className: (0,clsx/* default */.Z)(classes.barsLoader, className), ...others, ref, children: [
  /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: classes.bar }),
  /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: classes.bar }),
  /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: classes.bar })
] }));


//# sourceMappingURL=Bars.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Loader/loaders/Dots.mjs
'use client';













const Dots = (0,react.forwardRef)(({ className, ...others }, ref) => /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, { component: "span", className: (0,clsx/* default */.Z)(classes.dotsLoader, className), ...others, ref, children: [
  /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: classes.dot }),
  /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: classes.dot }),
  /* @__PURE__ */ (0,jsx_runtime.jsx)("span", { className: classes.dot })
] }));


//# sourceMappingURL=Dots.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Loader/loaders/Oval.mjs
'use client';













const Oval = (0,react.forwardRef)(({ className, ...others }, ref) => /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, { component: "span", className: (0,clsx/* default */.Z)(classes.ovalLoader, className), ...others, ref }));


//# sourceMappingURL=Oval.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Loader/Loader.mjs
'use client';






















const defaultLoaders = {
  bars: Bars,
  oval: Oval,
  dots: Dots
};
const defaultProps = {
  loaders: defaultLoaders,
  type: "oval"
};
const varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)((theme, { size, color }) => ({
  root: {
    "--loader-size": (0,get_size/* getSize */.ap)(size, "loader-size"),
    "--loader-color": color ? (0,get_theme_color/* getThemeColor */.p)(color, theme) : void 0
  }
}));
const Loader = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("Loader", defaultProps, _props);
  const {
    size,
    color,
    type,
    vars,
    className,
    style,
    classNames,
    styles,
    unstyled,
    loaders,
    variant,
    children,
    ...others
  } = props;
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: "Loader",
    props,
    classes: classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  if (children) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, { ...getStyles("root"), ref, ...others, children });
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ...getStyles("root"),
      ref,
      component: loaders[type],
      variant,
      size,
      ...others
    }
  );
});
Loader.defaultLoaders = defaultLoaders;
Loader.classes = classes;
Loader.displayName = "@mantine/core/Loader";


//# sourceMappingURL=Loader.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Transition/Transition.mjs + 5 modules
var Transition = __webpack_require__(44330);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/UnstyledButton/UnstyledButton.mjs + 1 modules
var UnstyledButton = __webpack_require__(77804);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Button/Button.module.css.mjs
'use client';
var Button_module_css_classes = {"root":"m_77c9d27d","inner":"m_80f1301b","label":"m_811560b9","section":"m_a74036a","loader":"m_a25b86ee","group":"m_80d6d844"};


//# sourceMappingURL=Button.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Button/ButtonGroup/ButtonGroup.mjs
'use client';


















const ButtonGroup_defaultProps = {
  orientation: "horizontal"
};
const ButtonGroup_varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)((_, { borderWidth }) => ({
  group: { "--button-border-width": (0,rem/* rem */.h)(borderWidth) }
}));
const ButtonGroup = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("ButtonGroup", ButtonGroup_defaultProps, _props);
  const {
    className,
    style,
    classNames,
    styles,
    unstyled,
    orientation,
    vars,
    borderWidth,
    variant,
    mod,
    ...others
  } = (0,use_props/* useProps */.w)("ButtonGroup", ButtonGroup_defaultProps, _props);
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: "ButtonGroup",
    props,
    classes: Button_module_css_classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: ButtonGroup_varsResolver,
    rootSelector: "group"
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ...getStyles("group"),
      ref,
      variant,
      mod: [{ "data-orientation": orientation }, mod],
      role: "group",
      ...others
    }
  );
});
ButtonGroup.classes = Button_module_css_classes;
ButtonGroup.displayName = "@mantine/core/ButtonGroup";


//# sourceMappingURL=ButtonGroup.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Button/Button.mjs
'use client';
























const loaderTransition = {
  in: { opacity: 1, transform: `translate(-50%, calc(-50% + ${(0,rem/* rem */.h)(1)}))` },
  out: { opacity: 0, transform: "translate(-50%, -200%)" },
  common: { transformOrigin: "center" },
  transitionProperty: "transform, opacity"
};
const Button_defaultProps = {};
const Button_varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)(
  (theme, { radius, color, gradient, variant, size, justify, autoContrast }) => {
    const colors = theme.variantColorResolver({
      color: color || theme.primaryColor,
      theme,
      gradient,
      variant: variant || "filled",
      autoContrast
    });
    return {
      root: {
        "--button-justify": justify,
        "--button-height": (0,get_size/* getSize */.ap)(size, "button-height"),
        "--button-padding-x": (0,get_size/* getSize */.ap)(size, "button-padding-x"),
        "--button-fz": size?.includes("compact") ? (0,get_size/* getFontSize */.yv)(size.replace("compact-", "")) : (0,get_size/* getFontSize */.yv)(size),
        "--button-radius": radius === void 0 ? void 0 : (0,get_size/* getRadius */.H5)(radius),
        "--button-bg": color || variant ? colors.background : void 0,
        "--button-hover": color || variant ? colors.hover : void 0,
        "--button-color": colors.color,
        "--button-bd": color || variant ? colors.border : void 0,
        "--button-hover-color": color || variant ? colors.hoverColor : void 0
      }
    };
  }
);
const Button = (0,polymorphic_factory/* polymorphicFactory */.b)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("Button", Button_defaultProps, _props);
  const {
    style,
    vars,
    className,
    color,
    disabled,
    children,
    leftSection,
    rightSection,
    fullWidth,
    variant,
    radius,
    loading,
    loaderProps,
    gradient,
    classNames,
    styles,
    unstyled,
    "data-disabled": dataDisabled,
    autoContrast,
    mod,
    ...others
  } = props;
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: "Button",
    props,
    classes: Button_module_css_classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: Button_varsResolver
  });
  const hasLeftSection = !!leftSection;
  const hasRightSection = !!rightSection;
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(
    UnstyledButton/* UnstyledButton */.k,
    {
      ref,
      ...getStyles("root", { active: !disabled && !loading && !dataDisabled }),
      unstyled,
      variant,
      disabled: disabled || loading,
      mod: [
        {
          disabled: disabled || dataDisabled,
          loading,
          block: fullWidth,
          "with-left-section": hasLeftSection,
          "with-right-section": hasRightSection
        },
        mod
      ],
      ...others,
      children: [
        /* @__PURE__ */ (0,jsx_runtime.jsx)(Transition/* Transition */.u, { mounted: !!loading, transition: loaderTransition, duration: 150, children: (transitionStyles) => /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, { component: "span", ...getStyles("loader", { style: transitionStyles }), "aria-hidden": true, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
          Loader,
          {
            color: "var(--button-color)",
            size: "calc(var(--button-height) / 1.8)",
            ...loaderProps
          }
        ) }) }),
        /* @__PURE__ */ (0,jsx_runtime.jsxs)("span", { ...getStyles("inner"), children: [
          leftSection && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, { component: "span", ...getStyles("section"), mod: { position: "left" }, children: leftSection }),
          /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, { component: "span", mod: { loading }, ...getStyles("label"), children }),
          rightSection && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, { component: "span", ...getStyles("section"), mod: { position: "right" }, children: rightSection })
        ] })
      ]
    }
  );
});
Button.classes = Button_module_css_classes;
Button.displayName = "@mantine/core/Button";
Button.Group = ButtonGroup;


//# sourceMappingURL=Button.mjs.map


/***/ }),

/***/ 92297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* unused harmony export CheckboxIcon */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _core_utils_units_converters_rem_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38292);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
'use client';













function CheckIcon({ size, style, ...others }) {
  const _style = size !== void 0 ? { width: (0,_core_utils_units_converters_rem_mjs__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .h)(size), height: (0,_core_utils_units_converters_rem_mjs__WEBPACK_IMPORTED_MODULE_2__/* .rem */ .h)(size), ...style } : style;
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
    "svg",
    {
      viewBox: "0 0 10 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: _style,
      "aria-hidden": true,
      ...others,
      children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(
        "path",
        {
          d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    }
  );
}
function CheckboxIcon({ indeterminate, ...others }) {
  if (indeterminate) {
    return /* @__PURE__ */ jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 6",
        "aria-hidden": true,
        ...others,
        children: /* @__PURE__ */ jsx("rect", { width: "32", height: "6", fill: "currentColor", rx: "3" })
      }
    );
  }
  return /* @__PURE__ */ jsx(CheckIcon, { ...others });
}


//# sourceMappingURL=CheckIcon.mjs.map


/***/ }),

/***/ 96644:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ Combobox; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/utils/units-converters/rem.mjs
var rem = __webpack_require__(38292);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/utils/get-size/get-size.mjs
var get_size = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/styles-api/create-vars-resolver/create-vars-resolver.mjs
var create_vars_resolver = __webpack_require__(79346);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/MantineProvider/use-props/use-props.mjs
var use_props = __webpack_require__(57285);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/styles-api/use-styles/use-styles.mjs + 17 modules
var use_styles = __webpack_require__(21413);
// EXTERNAL MODULE: ../../node_modules/@mantine/hooks/esm/use-id/use-id.mjs + 1 modules
var use_id = __webpack_require__(17220);
;// CONCATENATED MODULE: ../../node_modules/@mantine/hooks/esm/use-click-outside/use-click-outside.mjs
'use client';


const DEFAULT_EVENTS = ["mousedown", "touchstart"];
function useClickOutside(handler, events, nodes) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    const listener = (event) => {
      const { target } = event ?? {};
      if (Array.isArray(nodes)) {
        const shouldIgnore = target?.hasAttribute("data-ignore-outside-clicks") || !document.body.contains(target) && target.tagName !== "HTML";
        const shouldTrigger = nodes.every((node) => !!node && !event.composedPath().includes(node));
        shouldTrigger && !shouldIgnore && handler();
      } else if (ref.current && !ref.current.contains(target)) {
        handler();
      }
    };
    (events || DEFAULT_EVENTS).forEach((fn) => document.addEventListener(fn, listener));
    return () => {
      (events || DEFAULT_EVENTS).forEach((fn) => document.removeEventListener(fn, listener));
    };
  }, [ref, handler, nodes]);
  return ref;
}


//# sourceMappingURL=use-click-outside.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/utils/get-default-z-index/get-default-z-index.mjs
var get_default_z_index = __webpack_require__(7838);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/DirectionProvider/DirectionProvider.mjs
var DirectionProvider = __webpack_require__(14048);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Floating/get-floating-position/get-floating-position.mjs
var get_floating_position = __webpack_require__(16725);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/core/utils/create-safe-context/create-safe-context.mjs
'use client';



function createSafeContext(errorMessage) {
  const Context = (0,react.createContext)(null);
  const useSafeContext = () => {
    const ctx = (0,react.useContext)(Context);
    if (ctx === null) {
      throw new Error(errorMessage);
    }
    return ctx;
  };
  const Provider = ({ children, value }) => /* @__PURE__ */ (0,jsx_runtime.jsx)(Context.Provider, { value, children });
  return [Provider, useSafeContext];
}


//# sourceMappingURL=create-safe-context.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Popover/Popover.context.mjs
'use client';













const [PopoverContextProvider, usePopoverContext] = createSafeContext(
  "Popover component was not found in the tree"
);


//# sourceMappingURL=Popover.context.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/hooks/esm/use-did-update/use-did-update.mjs
var use_did_update = __webpack_require__(54459);
;// CONCATENATED MODULE: ../../node_modules/@mantine/hooks/esm/use-focus-return/use-focus-return.mjs
'use client';



function useFocusReturn({ opened, shouldReturnFocus = true }) {
  const lastActiveElement = (0,react.useRef)();
  const returnFocus = () => {
    if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") {
      lastActiveElement.current?.focus({ preventScroll: true });
    }
  };
  (0,use_did_update/* useDidUpdate */.l)(() => {
    let timeout = -1;
    const clearFocusTimeout = (event) => {
      if (event.key === "Tab") {
        window.clearTimeout(timeout);
      }
    };
    document.addEventListener("keydown", clearFocusTimeout);
    if (opened) {
      lastActiveElement.current = document.activeElement;
    } else if (shouldReturnFocus) {
      timeout = window.setTimeout(returnFocus, 10);
    }
    return () => {
      window.clearTimeout(timeout);
      document.removeEventListener("keydown", clearFocusTimeout);
    };
  }, [opened, shouldReturnFocus]);
  return returnFocus;
}


//# sourceMappingURL=use-focus-return.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/hooks/esm/use-merged-ref/use-merged-ref.mjs
var use_merged_ref = __webpack_require__(15850);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/core/utils/noop/noop.mjs
'use client';
const noop = () => {
};


//# sourceMappingURL=noop.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/core/utils/close-on-escape/close-on-escape.mjs
'use client';


function closeOnEscape(callback, options = { active: true }) {
  if (typeof callback !== "function" || !options.active) {
    return options.onKeyDown || noop;
  }
  return (event) => {
    if (event.key === "Escape") {
      callback(event);
      options.onTrigger?.();
    }
  };
}


//# sourceMappingURL=close-on-escape.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/Box/Box.mjs + 21 modules
var Box = __webpack_require__(46293);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/factory/factory.mjs
var factory = __webpack_require__(21774);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Floating/FloatingArrow/FloatingArrow.mjs + 1 modules
var FloatingArrow = __webpack_require__(97177);
// EXTERNAL MODULE: ../../node_modules/@mantine/hooks/esm/utils/random-id/random-id.mjs
var random_id = __webpack_require__(36122);
;// CONCATENATED MODULE: ../../node_modules/@mantine/hooks/esm/use-focus-trap/create-aria-hider.mjs
'use client';


function createAriaHider(containerNode, selector = "body > :not(script)") {
  const id = (0,random_id/* randomId */.k)();
  const rootNodes = Array.from(
    document.querySelectorAll(selector)
  ).map((node) => {
    if (node?.shadowRoot?.contains(containerNode) || node.contains(containerNode)) {
      return void 0;
    }
    const ariaHidden = node.getAttribute("aria-hidden");
    const prevAriaHidden = node.getAttribute("data-hidden");
    const prevFocusId = node.getAttribute("data-focus-id");
    node.setAttribute("data-focus-id", id);
    if (ariaHidden === null || ariaHidden === "false") {
      node.setAttribute("aria-hidden", "true");
    } else if (!prevAriaHidden && !prevFocusId) {
      node.setAttribute("data-hidden", ariaHidden);
    }
    return {
      node,
      ariaHidden: prevAriaHidden || null
    };
  });
  return () => {
    rootNodes.forEach((item) => {
      if (!item || id !== item.node.getAttribute("data-focus-id")) {
        return;
      }
      if (item.ariaHidden === null) {
        item.node.removeAttribute("aria-hidden");
      } else {
        item.node.setAttribute("aria-hidden", item.ariaHidden);
      }
      item.node.removeAttribute("data-focus-id");
      item.node.removeAttribute("data-hidden");
    });
  };
}


//# sourceMappingURL=create-aria-hider.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/hooks/esm/use-focus-trap/tabbable.mjs
'use client';
const TABBABLE_NODES = /input|select|textarea|button|object/;
const FOCUS_SELECTOR = "a, input, select, textarea, button, object, [tabindex]";
function tabbable_hidden(element) {
  if (false) {}
  return element.style.display === "none";
}
function visible(element) {
  const isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
  if (isHidden) {
    return false;
  }
  let parentElement = element;
  while (parentElement) {
    if (parentElement === document.body || parentElement.nodeType === 11) {
      break;
    }
    if (tabbable_hidden(parentElement)) {
      return false;
    }
    parentElement = parentElement.parentNode;
  }
  return true;
}
function getElementTabIndex(element) {
  let tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) {
    tabIndex = void 0;
  }
  return parseInt(tabIndex, 10);
}
function focusable(element) {
  const nodeName = element.nodeName.toLowerCase();
  const isTabIndexNotNaN = !Number.isNaN(getElementTabIndex(element));
  const res = (
    // @ts-expect-error function accepts any html element but if it is a button, it should not be disabled to trigger the condition
    TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN)
  );
  return res && visible(element);
}
function tabbable(element) {
  const tabIndex = getElementTabIndex(element);
  const isTabIndexNaN = Number.isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function findTabbableDescendants(element) {
  return Array.from(element.querySelectorAll(FOCUS_SELECTOR)).filter(tabbable);
}


//# sourceMappingURL=tabbable.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/hooks/esm/use-focus-trap/scope-tab.mjs
'use client';


function scopeTab(node, event) {
  const tabbable = findTabbableDescendants(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  const finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  const root = node.getRootNode();
  let leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
  const activeElement = root.activeElement;
  const activeElementIsRadio = activeElement.tagName === "INPUT" && activeElement.getAttribute("type") === "radio";
  if (activeElementIsRadio) {
    const activeRadioGroup = tabbable.filter(
      (element) => element.getAttribute("type") === "radio" && element.getAttribute("name") === activeElement.getAttribute("name")
    );
    leavingFinalTabbable = activeRadioGroup.includes(finalTabbable);
  }
  if (!leavingFinalTabbable) {
    return;
  }
  event.preventDefault();
  const target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  if (target) {
    target.focus();
  }
}


//# sourceMappingURL=scope-tab.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/hooks/esm/use-focus-trap/use-focus-trap.mjs
'use client';





function useFocusTrap(active = true) {
  const ref = (0,react.useRef)();
  const restoreAria = (0,react.useRef)(null);
  const focusNode = (node) => {
    let focusElement = node.querySelector("[data-autofocus]");
    if (!focusElement) {
      const children = Array.from(node.querySelectorAll(FOCUS_SELECTOR));
      focusElement = children.find(tabbable) || children.find(focusable) || null;
      if (!focusElement && focusable(node))
        focusElement = node;
    }
    if (focusElement) {
      focusElement.focus({ preventScroll: true });
    } else if (false) {}
  };
  const setRef = (0,react.useCallback)(
    (node) => {
      if (!active) {
        return;
      }
      if (node === null) {
        if (restoreAria.current) {
          restoreAria.current();
          restoreAria.current = null;
        }
        return;
      }
      restoreAria.current = createAriaHider(node);
      if (ref.current === node) {
        return;
      }
      if (node) {
        setTimeout(() => {
          if (node.getRootNode()) {
            focusNode(node);
          } else if (false) {}
        });
        ref.current = node;
      } else {
        ref.current = null;
      }
    },
    [active]
  );
  (0,react.useEffect)(() => {
    if (!active) {
      return void 0;
    }
    ref.current && setTimeout(() => focusNode(ref.current));
    const handleKeyDown = (event) => {
      if (event.key === "Tab" && ref.current) {
        scopeTab(ref.current, event);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      if (restoreAria.current) {
        restoreAria.current();
      }
    };
  }, [active]);
  return setRef;
}


//# sourceMappingURL=use-focus-trap.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/utils/is-element/is-element.mjs
var is_element = __webpack_require__(45561);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/VisuallyHidden/VisuallyHidden.module.css.mjs
'use client';
var classes = {"root":"m_515a97f8"};


//# sourceMappingURL=VisuallyHidden.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/VisuallyHidden/VisuallyHidden.mjs
'use client';
















const defaultProps = {};
const VisuallyHidden = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("VisuallyHidden", defaultProps, _props);
  const { classNames, className, style, styles, unstyled, vars, ...others } = props;
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: "VisuallyHidden",
    classes: classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, { component: "span", ref, ...getStyles("root"), ...others });
});
VisuallyHidden.classes = classes;
VisuallyHidden.displayName = "@mantine/core/VisuallyHidden";


//# sourceMappingURL=VisuallyHidden.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/FocusTrap/FocusTrap.mjs
'use client';














function FocusTrap({
  children,
  active = true,
  refProp = "ref"
}) {
  const focusTrapRef = useFocusTrap(active);
  const ref = (0,use_merged_ref/* useMergedRef */.Yx)(focusTrapRef, children?.ref);
  if (!(0,is_element/* isElement */.k)(children)) {
    return children;
  }
  return (0,react.cloneElement)(children, { [refProp]: ref });
}
function FocusTrapInitialFocus(props) {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(VisuallyHidden, { tabIndex: -1, "data-autofocus": true, ...props });
}
FocusTrap.displayName = "@mantine/core/FocusTrap";
FocusTrapInitialFocus.displayName = "@mantine/core/FocusTrapInitialFocus";
FocusTrap.InitialFocus = FocusTrapInitialFocus;


//# sourceMappingURL=FocusTrap.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Portal/OptionalPortal.mjs + 1 modules
var OptionalPortal = __webpack_require__(38032);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Transition/Transition.mjs + 5 modules
var Transition = __webpack_require__(44330);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Popover/Popover.module.css.mjs
'use client';
var Popover_module_css_classes = {"dropdown":"m_38a85659","arrow":"m_a31dc6c1"};


//# sourceMappingURL=Popover.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Popover/PopoverDropdown/PopoverDropdown.mjs
'use client';

























const PopoverDropdown_defaultProps = {};
const PopoverDropdown = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("PopoverDropdown", PopoverDropdown_defaultProps, _props);
  const {
    className,
    style,
    vars,
    children,
    onKeyDownCapture,
    variant,
    classNames,
    styles,
    ...others
  } = props;
  const ctx = usePopoverContext();
  const returnFocus = useFocusReturn({
    opened: ctx.opened,
    shouldReturnFocus: ctx.returnFocus
  });
  const accessibleProps = ctx.withRoles ? {
    "aria-labelledby": ctx.getTargetId(),
    id: ctx.getDropdownId(),
    role: "dialog",
    tabIndex: -1
  } : {};
  const mergedRef = (0,use_merged_ref/* useMergedRef */.Yx)(ref, ctx.floating);
  if (ctx.disabled) {
    return null;
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(OptionalPortal/* OptionalPortal */.q, { ...ctx.portalProps, withinPortal: ctx.withinPortal, children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Transition/* Transition */.u,
    {
      mounted: ctx.opened,
      ...ctx.transitionProps,
      transition: ctx.transitionProps?.transition || "fade",
      duration: ctx.transitionProps?.duration ?? 150,
      keepMounted: ctx.keepMounted,
      exitDuration: typeof ctx.transitionProps?.exitDuration === "number" ? ctx.transitionProps.exitDuration : ctx.transitionProps?.duration,
      children: (transitionStyles) => /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusTrap, { active: ctx.trapFocus, children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(
        Box/* Box */.x,
        {
          ...accessibleProps,
          ...others,
          variant,
          ref: mergedRef,
          onKeyDownCapture: closeOnEscape(ctx.onClose, {
            active: ctx.closeOnEscape,
            onTrigger: returnFocus,
            onKeyDown: onKeyDownCapture
          }),
          "data-position": ctx.placement,
          ...ctx.getStyles("dropdown", {
            className,
            props,
            classNames,
            styles,
            style: [
              {
                ...transitionStyles,
                zIndex: ctx.zIndex,
                top: ctx.y ?? 0,
                left: ctx.x ?? 0,
                width: ctx.width === "target" ? void 0 : (0,rem/* rem */.h)(ctx.width)
              },
              style
            ]
          }),
          children: [
            children,
            /* @__PURE__ */ (0,jsx_runtime.jsx)(
              FloatingArrow/* FloatingArrow */.Y,
              {
                ref: ctx.arrowRef,
                arrowX: ctx.arrowX,
                arrowY: ctx.arrowY,
                visible: ctx.withArrow,
                position: ctx.placement,
                arrowSize: ctx.arrowSize,
                arrowRadius: ctx.arrowRadius,
                arrowOffset: ctx.arrowOffset,
                arrowPosition: ctx.arrowPosition,
                ...ctx.getStyles("arrow", {
                  props,
                  classNames,
                  styles
                })
              }
            )
          ]
        }
      ) })
    }
  ) });
});
PopoverDropdown.classes = Popover_module_css_classes;
PopoverDropdown.displayName = "@mantine/core/PopoverDropdown";


//# sourceMappingURL=PopoverDropdown.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(84419);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Popover/PopoverTarget/PopoverTarget.mjs
'use client';
















const PopoverTarget_defaultProps = {
  refProp: "ref",
  popupType: "dialog"
};
const PopoverTarget = (0,factory/* factory */.d)((props, ref) => {
  const { children, refProp, popupType, ...others } = (0,use_props/* useProps */.w)(
    "PopoverTarget",
    PopoverTarget_defaultProps,
    props
  );
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(
      "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  }
  const forwardedProps = others;
  const ctx = usePopoverContext();
  const targetRef = (0,use_merged_ref/* useMergedRef */.Yx)(ctx.reference, children.ref, ref);
  const accessibleProps = ctx.withRoles ? {
    "aria-haspopup": popupType,
    "aria-expanded": ctx.opened,
    "aria-controls": ctx.getDropdownId(),
    id: ctx.getTargetId()
  } : {};
  return (0,react.cloneElement)(children, {
    ...forwardedProps,
    ...accessibleProps,
    ...ctx.targetProps,
    className: (0,clsx/* default */.Z)(ctx.targetProps.className, forwardedProps.className, children.props.className),
    [refProp]: targetRef,
    ...!ctx.controlled ? { onClick: ctx.onToggle } : null
  });
});
PopoverTarget.displayName = "@mantine/core/PopoverTarget";


//# sourceMappingURL=PopoverTarget.mjs.map

// EXTERNAL MODULE: ../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(92416);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/react/dist/floating-ui.react.mjs + 1 modules
var floating_ui_react = __webpack_require__(63607);
// EXTERNAL MODULE: ../../node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.mjs
var use_uncontrolled = __webpack_require__(70464);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Floating/use-floating-auto-update.mjs
var use_floating_auto_update = __webpack_require__(6534);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Popover/use-popover.mjs
'use client';






function getDefaultMiddlewares(middlewares) {
  if (middlewares === void 0) {
    return { shift: true, flip: true };
  }
  const result = { ...middlewares };
  if (middlewares.shift === void 0) {
    result.shift = true;
  }
  if (middlewares.flip === void 0) {
    result.flip = true;
  }
  return result;
}
function getPopoverMiddlewares(options, getFloating) {
  const middlewaresOptions = getDefaultMiddlewares(options.middlewares);
  const middlewares = [(0,floating_ui_react_dom/* offset */.cv)(options.offset)];
  if (middlewaresOptions.shift) {
    middlewares.push(
      (0,floating_ui_react_dom/* shift */.uY)(
        typeof middlewaresOptions.shift === "boolean" ? { limiter: (0,floating_ui_react_dom/* limitShift */.dr)(), padding: 5 } : { limiter: (0,floating_ui_react_dom/* limitShift */.dr)(), padding: 5, ...middlewaresOptions.shift }
      )
    );
  }
  if (middlewaresOptions.flip) {
    middlewares.push(
      typeof middlewaresOptions.flip === "boolean" ? (0,floating_ui_react_dom/* flip */.RR)() : (0,floating_ui_react_dom/* flip */.RR)(middlewaresOptions.flip)
    );
  }
  if (middlewaresOptions.inline) {
    middlewares.push(
      typeof middlewaresOptions.inline === "boolean" ? (0,floating_ui_react_dom/* inline */.Qo)() : (0,floating_ui_react_dom/* inline */.Qo)(middlewaresOptions.inline)
    );
  }
  middlewares.push((0,floating_ui_react_dom/* arrow */.x7)({ element: options.arrowRef, padding: options.arrowOffset }));
  if (middlewaresOptions.size || options.width === "target") {
    middlewares.push(
      (0,floating_ui_react_dom/* size */.dp)({
        ...typeof middlewaresOptions.size === "boolean" ? {} : middlewaresOptions.size,
        apply({ rects, availableWidth, availableHeight }) {
          const floating = getFloating();
          const styles = floating.refs.floating.current?.style ?? {};
          if (middlewaresOptions.size) {
            Object.assign(styles, {
              maxWidth: `${availableWidth}px`,
              maxHeight: `${availableHeight}px`
            });
          }
          if (options.width === "target") {
            Object.assign(styles, {
              width: `${rects.reference.width}px`
            });
          }
        }
      })
    );
  }
  return middlewares;
}
function usePopover(options) {
  const [_opened, setOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: options.opened,
    defaultValue: options.defaultOpened,
    finalValue: false,
    onChange: options.onChange
  });
  const onClose = () => {
    if (_opened) {
      options.onClose?.();
      setOpened(false);
    }
  };
  const onToggle = () => {
    if (_opened) {
      options.onClose?.();
      setOpened(false);
    } else {
      options.onOpen?.();
      setOpened(true);
    }
  };
  const floating = (0,floating_ui_react/* useFloating */.YF)({
    strategy: options.strategy,
    placement: options.position,
    middleware: getPopoverMiddlewares(options, () => floating)
  });
  (0,use_floating_auto_update/* useFloatingAutoUpdate */.L)({
    opened: options.opened,
    position: options.position,
    positionDependencies: options.positionDependencies || [],
    floating
  });
  (0,use_did_update/* useDidUpdate */.l)(() => {
    options.onPositionChange?.(floating.placement);
  }, [floating.placement]);
  (0,use_did_update/* useDidUpdate */.l)(() => {
    if (!options.opened) {
      options.onClose?.();
    } else {
      options.onOpen?.();
    }
  }, [options.opened]);
  return {
    floating,
    controlled: typeof options.opened === "boolean",
    opened: _opened,
    onClose,
    onToggle
  };
}


//# sourceMappingURL=use-popover.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Popover/Popover.mjs
'use client';

























const Popover_defaultProps = {
  position: "bottom",
  offset: 8,
  positionDependencies: [],
  transitionProps: { transition: "fade", duration: 150 },
  middlewares: { flip: true, shift: true, inline: false },
  arrowSize: 7,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  closeOnClickOutside: true,
  withinPortal: true,
  closeOnEscape: true,
  trapFocus: false,
  withRoles: true,
  returnFocus: false,
  clickOutsideEvents: ["mousedown", "touchstart"],
  zIndex: (0,get_default_z_index/* getDefaultZIndex */.w)("popover"),
  __staticSelector: "Popover",
  width: "max-content"
};
const varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)((_, { radius, shadow }) => ({
  dropdown: {
    "--popover-radius": radius === void 0 ? void 0 : (0,get_size/* getRadius */.H5)(radius),
    "--popover-shadow": (0,get_size/* getShadow */.Xj)(shadow)
  }
}));
function Popover(_props) {
  const props = (0,use_props/* useProps */.w)("Popover", Popover_defaultProps, _props);
  const {
    children,
    position,
    offset,
    onPositionChange,
    positionDependencies,
    opened,
    transitionProps,
    width,
    middlewares,
    withArrow,
    arrowSize,
    arrowOffset,
    arrowRadius,
    arrowPosition,
    unstyled,
    classNames,
    styles,
    closeOnClickOutside,
    withinPortal,
    portalProps,
    closeOnEscape,
    clickOutsideEvents,
    trapFocus,
    onClose,
    onOpen,
    onChange,
    zIndex,
    radius,
    shadow,
    id,
    defaultOpened,
    __staticSelector,
    withRoles,
    disabled,
    returnFocus,
    variant,
    keepMounted,
    vars,
    floatingStrategy,
    ...others
  } = props;
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: __staticSelector,
    props,
    classes: Popover_module_css_classes,
    classNames,
    styles,
    unstyled,
    rootSelector: "dropdown",
    vars,
    varsResolver
  });
  const arrowRef = (0,react.useRef)(null);
  const [targetNode, setTargetNode] = (0,react.useState)(null);
  const [dropdownNode, setDropdownNode] = (0,react.useState)(null);
  const { dir } = (0,DirectionProvider/* useDirection */.gm)();
  const uid = (0,use_id/* useId */.M)(id);
  const popover = usePopover({
    middlewares,
    width,
    position: (0,get_floating_position/* getFloatingPosition */._)(dir, position),
    offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
    arrowRef,
    arrowOffset,
    onPositionChange,
    positionDependencies,
    opened,
    defaultOpened,
    onChange,
    onOpen,
    onClose,
    strategy: floatingStrategy
  });
  useClickOutside(() => closeOnClickOutside && popover.onClose(), clickOutsideEvents, [
    targetNode,
    dropdownNode
  ]);
  const reference = (0,react.useCallback)(
    (node) => {
      setTargetNode(node);
      popover.floating.refs.setReference(node);
    },
    [popover.floating.refs.setReference]
  );
  const floating = (0,react.useCallback)(
    (node) => {
      setDropdownNode(node);
      popover.floating.refs.setFloating(node);
    },
    [popover.floating.refs.setFloating]
  );
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    PopoverContextProvider,
    {
      value: {
        returnFocus,
        disabled,
        controlled: popover.controlled,
        reference,
        floating,
        x: popover.floating.x,
        y: popover.floating.y,
        arrowX: popover.floating?.middlewareData?.arrow?.x,
        arrowY: popover.floating?.middlewareData?.arrow?.y,
        opened: popover.opened,
        arrowRef,
        transitionProps,
        width,
        withArrow,
        arrowSize,
        arrowOffset,
        arrowRadius,
        arrowPosition,
        placement: popover.floating.placement,
        trapFocus,
        withinPortal,
        portalProps,
        zIndex,
        radius,
        shadow,
        closeOnEscape,
        onClose: popover.onClose,
        onToggle: popover.onToggle,
        getTargetId: () => `${uid}-target`,
        getDropdownId: () => `${uid}-dropdown`,
        withRoles,
        targetProps: others,
        __staticSelector,
        classNames,
        styles,
        unstyled,
        variant,
        keepMounted,
        getStyles
      },
      children
    }
  );
}
Popover.Target = PopoverTarget;
Popover.Dropdown = PopoverDropdown;
Popover.displayName = "@mantine/core/Popover";
Popover.extend = (input) => input;


//# sourceMappingURL=Popover.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/Combobox.context.mjs
'use client';













const [ComboboxProvider, useComboboxContext] = createSafeContext(
  "Combobox component was not found in tree"
);


//# sourceMappingURL=Combobox.context.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/Combobox.module.css.mjs
'use client';
var Combobox_module_css_classes = {"dropdown":"m_88b62a41","options":"m_b2821a6e","option":"m_92253aa5","search":"m_985517d8","empty":"m_2530cd1d","header":"m_858f94bd","footer":"m_82b967cb","group":"m_254f3e4f","groupLabel":"m_2bb2e9e5","chevron":"m_2943220b","optionsDropdownOption":"m_390b5f4","optionsDropdownCheckIcon":"m_8ee53fc2"};


//# sourceMappingURL=Combobox.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxChevron/ComboboxChevron.mjs
'use client';


















const ComboboxChevron_defaultProps = {
  error: null
};
const ComboboxChevron_varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)((_, { size }) => ({
  chevron: {
    "--combobox-chevron-size": (0,get_size/* getSize */.ap)(size, "combobox-chevron-size")
  }
}));
const ComboboxChevron = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("ComboboxChevron", ComboboxChevron_defaultProps, _props);
  const { size, error, style, className, classNames, styles, unstyled, vars, mod, ...others } = props;
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: "ComboboxChevron",
    classes: Combobox_module_css_classes,
    props,
    style,
    className,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: ComboboxChevron_varsResolver,
    rootSelector: "chevron"
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      component: "svg",
      ...others,
      ...getStyles("chevron"),
      size,
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      mod: ["combobox-chevron", { error }, mod],
      ref,
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
        "path",
        {
          d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    }
  );
});
ComboboxChevron.classes = Combobox_module_css_classes;
ComboboxChevron.displayName = "@mantine/core/ComboboxChevron";


//# sourceMappingURL=ComboboxChevron.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/factory/polymorphic-factory.mjs
var polymorphic_factory = __webpack_require__(10046);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/UnstyledButton/UnstyledButton.mjs + 1 modules
var UnstyledButton = __webpack_require__(77804);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/CloseButton/CloseIcon.mjs
'use client';



const CloseIcon = (0,react.forwardRef)(
  ({ size = "var(--cb-icon-size, 70%)", style, ...others }, ref) => /* @__PURE__ */ (0,jsx_runtime.jsx)(
    "svg",
    {
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: { ...style, width: size, height: size },
      ref,
      ...others,
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
        "path",
        {
          d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    }
  )
);
CloseIcon.displayName = "@mantine/core/CloseIcon";


//# sourceMappingURL=CloseIcon.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/CloseButton/CloseButton.module.css.mjs
'use client';
var CloseButton_module_css_classes = {"root":"m_86a44da5","root--subtle":"m_220c80f2"};


//# sourceMappingURL=CloseButton.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/CloseButton/CloseButton.mjs
'use client';





















const CloseButton_defaultProps = {
  variant: "subtle"
};
const CloseButton_varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)((_, { size, radius, iconSize }) => ({
  root: {
    "--cb-size": (0,get_size/* getSize */.ap)(size, "cb-size"),
    "--cb-radius": radius === void 0 ? void 0 : (0,get_size/* getRadius */.H5)(radius),
    "--cb-icon-size": (0,rem/* rem */.h)(iconSize)
  }
}));
const CloseButton = (0,polymorphic_factory/* polymorphicFactory */.b)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("CloseButton", CloseButton_defaultProps, _props);
  const {
    iconSize,
    children,
    vars,
    radius,
    className,
    classNames,
    style,
    styles,
    unstyled,
    "data-disabled": dataDisabled,
    disabled,
    variant,
    icon,
    mod,
    ...others
  } = props;
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: "CloseButton",
    props,
    className,
    style,
    classes: CloseButton_module_css_classes,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: CloseButton_varsResolver
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(
    UnstyledButton/* UnstyledButton */.k,
    {
      ref,
      ...others,
      unstyled,
      variant,
      disabled,
      mod: [{ disabled: disabled || dataDisabled }, mod],
      ...getStyles("root", { variant, active: !disabled && !dataDisabled }),
      children: [
        icon || /* @__PURE__ */ (0,jsx_runtime.jsx)(CloseIcon, {}),
        children
      ]
    }
  );
});
CloseButton.classes = CloseButton_module_css_classes;
CloseButton.displayName = "@mantine/core/CloseButton";


//# sourceMappingURL=CloseButton.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxClearButton/ComboboxClearButton.mjs
'use client';





const ComboboxClearButton = (0,react.forwardRef)(
  ({ size, onMouseDown, onClick, onClear, ...others }, ref) => /* @__PURE__ */ (0,jsx_runtime.jsx)(
    CloseButton,
    {
      ref,
      size: size || "sm",
      variant: "transparent",
      tabIndex: -1,
      "aria-hidden": true,
      ...others,
      onMouseDown: (event) => {
        event.preventDefault();
        onMouseDown?.(event);
      },
      onClick: (event) => {
        onClear();
        onClick?.(event);
      }
    }
  )
);
ComboboxClearButton.displayName = "@mantine/core/ComboboxClearButton";


//# sourceMappingURL=ComboboxClearButton.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxDropdown/ComboboxDropdown.mjs
'use client';



















const ComboboxDropdown_defaultProps = {};
const ComboboxDropdown = (0,factory/* factory */.d)((props, ref) => {
  const { classNames, styles, className, style, hidden, ...others } = (0,use_props/* useProps */.w)(
    "ComboboxDropdown",
    ComboboxDropdown_defaultProps,
    props
  );
  const ctx = useComboboxContext();
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Popover.Dropdown,
    {
      ...others,
      ref,
      role: "presentation",
      "data-hidden": hidden || void 0,
      ...ctx.getStyles("dropdown", { className, style, classNames, styles })
    }
  );
});
ComboboxDropdown.classes = Combobox_module_css_classes;
ComboboxDropdown.displayName = "@mantine/core/ComboboxDropdown";


//# sourceMappingURL=ComboboxDropdown.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxDropdownTarget/ComboboxDropdownTarget.mjs
'use client';



















const ComboboxDropdownTarget_defaultProps = {
  refProp: "ref"
};
const ComboboxDropdownTarget = (0,factory/* factory */.d)((props, ref) => {
  const { children, refProp } = (0,use_props/* useProps */.w)("ComboboxDropdownTarget", ComboboxDropdownTarget_defaultProps, props);
  useComboboxContext();
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(
      "Combobox.DropdownTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  }
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Popover.Target, { ref, refProp, children });
});
ComboboxDropdownTarget.displayName = "@mantine/core/ComboboxDropdownTarget";


//# sourceMappingURL=ComboboxDropdownTarget.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxEmpty/ComboboxEmpty.mjs
'use client';
















const ComboboxEmpty_defaultProps = {};
const ComboboxEmpty = (0,factory/* factory */.d)((props, ref) => {
  const { classNames, className, style, styles, vars, ...others } = (0,use_props/* useProps */.w)(
    "ComboboxEmpty",
    ComboboxEmpty_defaultProps,
    props
  );
  const ctx = useComboboxContext();
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ref,
      ...ctx.getStyles("empty", { className, classNames, styles, style }),
      ...others
    }
  );
});
ComboboxEmpty.classes = Combobox_module_css_classes;
ComboboxEmpty.displayName = "@mantine/core/ComboboxEmpty";


//# sourceMappingURL=ComboboxEmpty.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/use-combobox-target-props/use-combobox-target-props.mjs
'use client';



function useComboboxTargetProps({
  onKeyDown,
  withKeyboardNavigation,
  withAriaAttributes,
  withExpandedAttribute,
  targetType,
  autoComplete
}) {
  const ctx = useComboboxContext();
  const [selectedOptionId, setSelectedOptionId] = (0,react.useState)(null);
  const handleKeyDown = (event) => {
    onKeyDown?.(event);
    if (ctx.readOnly) {
      return;
    }
    if (withKeyboardNavigation) {
      if (event.nativeEvent.isComposing)
        return;
      if (event.nativeEvent.code === "ArrowDown") {
        event.preventDefault();
        if (!ctx.store.dropdownOpened) {
          ctx.store.openDropdown("keyboard");
          setSelectedOptionId(ctx.store.selectActiveOption());
        } else {
          setSelectedOptionId(ctx.store.selectNextOption());
        }
      }
      if (event.nativeEvent.code === "ArrowUp") {
        event.preventDefault();
        if (!ctx.store.dropdownOpened) {
          ctx.store.openDropdown("keyboard");
          setSelectedOptionId(ctx.store.selectActiveOption());
        } else {
          setSelectedOptionId(ctx.store.selectPreviousOption());
        }
      }
      if (event.nativeEvent.code === "Enter" || event.nativeEvent.code === "NumpadEnter") {
        if (event.nativeEvent.keyCode === 229)
          return;
        const selectedOptionIndex = ctx.store.getSelectedOptionIndex();
        if (ctx.store.dropdownOpened && selectedOptionIndex !== -1) {
          event.preventDefault();
          ctx.store.clickSelectedOption();
        } else if (targetType === "button") {
          event.preventDefault();
          ctx.store.openDropdown("keyboard");
        }
      }
      if (event.nativeEvent.code === "Escape") {
        ctx.store.closeDropdown("keyboard");
      }
      if (event.nativeEvent.code === "Space") {
        if (targetType === "button") {
          event.preventDefault();
          ctx.store.toggleDropdown("keyboard");
        }
      }
    }
  };
  const ariaAttributes = withAriaAttributes ? {
    "aria-haspopup": "listbox",
    "aria-expanded": withExpandedAttribute && !!(ctx.store.listId && ctx.store.dropdownOpened) || void 0,
    "aria-controls": ctx.store.listId,
    "aria-activedescendant": ctx.store.dropdownOpened ? selectedOptionId || void 0 : void 0,
    autoComplete,
    "data-expanded": ctx.store.dropdownOpened || void 0,
    "data-mantine-stop-propagation": ctx.store.dropdownOpened || void 0
  } : {};
  return {
    ...ariaAttributes,
    onKeyDown: handleKeyDown
  };
}


//# sourceMappingURL=use-combobox-target-props.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxEventsTarget/ComboboxEventsTarget.mjs
'use client';

















const ComboboxEventsTarget_defaultProps = {
  refProp: "ref",
  targetType: "input",
  withKeyboardNavigation: true,
  withAriaAttributes: true,
  withExpandedAttribute: false,
  autoComplete: "off"
};
const ComboboxEventsTarget = (0,factory/* factory */.d)((props, ref) => {
  const {
    children,
    refProp,
    withKeyboardNavigation,
    withAriaAttributes,
    withExpandedAttribute,
    targetType,
    autoComplete,
    ...others
  } = (0,use_props/* useProps */.w)("ComboboxEventsTarget", ComboboxEventsTarget_defaultProps, props);
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(
      "Combobox.EventsTarget component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  }
  const ctx = useComboboxContext();
  const targetProps = useComboboxTargetProps({
    targetType,
    withAriaAttributes,
    withKeyboardNavigation,
    withExpandedAttribute,
    onKeyDown: children.props.onKeyDown,
    autoComplete
  });
  return (0,react.cloneElement)(children, {
    ...targetProps,
    ...others,
    [refProp]: (0,use_merged_ref/* useMergedRef */.Yx)(ref, ctx.store.targetRef, children?.ref)
  });
});
ComboboxEventsTarget.displayName = "@mantine/core/ComboboxEventsTarget";


//# sourceMappingURL=ComboboxEventsTarget.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxFooter/ComboboxFooter.mjs
'use client';
















const ComboboxFooter_defaultProps = {};
const ComboboxFooter = (0,factory/* factory */.d)((props, ref) => {
  const { classNames, className, style, styles, vars, ...others } = (0,use_props/* useProps */.w)(
    "ComboboxFooter",
    ComboboxFooter_defaultProps,
    props
  );
  const ctx = useComboboxContext();
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ref,
      ...ctx.getStyles("footer", { className, classNames, style, styles }),
      ...others
    }
  );
});
ComboboxFooter.classes = Combobox_module_css_classes;
ComboboxFooter.displayName = "@mantine/core/ComboboxFooter";


//# sourceMappingURL=ComboboxFooter.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxGroup/ComboboxGroup.mjs
'use client';
















const ComboboxGroup_defaultProps = {};
const ComboboxGroup = (0,factory/* factory */.d)((props, ref) => {
  const { classNames, className, style, styles, vars, children, label, ...others } = (0,use_props/* useProps */.w)(
    "ComboboxGroup",
    ComboboxGroup_defaultProps,
    props
  );
  const ctx = useComboboxContext();
  return /* @__PURE__ */ (0,jsx_runtime.jsxs)(
    Box/* Box */.x,
    {
      ref,
      ...ctx.getStyles("group", { className, classNames, style, styles }),
      ...others,
      children: [
        label && /* @__PURE__ */ (0,jsx_runtime.jsx)("div", { ...ctx.getStyles("groupLabel", { classNames, styles }), children: label }),
        children
      ]
    }
  );
});
ComboboxGroup.classes = Combobox_module_css_classes;
ComboboxGroup.displayName = "@mantine/core/ComboboxGroup";


//# sourceMappingURL=ComboboxGroup.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxHeader/ComboboxHeader.mjs
'use client';
















const ComboboxHeader_defaultProps = {};
const ComboboxHeader = (0,factory/* factory */.d)((props, ref) => {
  const { classNames, className, style, styles, vars, ...others } = (0,use_props/* useProps */.w)(
    "ComboboxHeader",
    ComboboxHeader_defaultProps,
    props
  );
  const ctx = useComboboxContext();
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ref,
      ...ctx.getStyles("header", { className, classNames, style, styles }),
      ...others
    }
  );
});
ComboboxHeader.classes = Combobox_module_css_classes;
ComboboxHeader.displayName = "@mantine/core/ComboboxHeader";


//# sourceMappingURL=ComboboxHeader.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxHiddenInput/ComboboxHiddenInput.mjs
'use client';


function ComboboxHiddenInput({
  value,
  valuesDivider = ",",
  ...others
}) {
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    "input",
    {
      type: "hidden",
      value: Array.isArray(value) ? value.join(valuesDivider) : value || "",
      ...others
    }
  );
}
ComboboxHiddenInput.displayName = "@mantine/core/ComboboxHiddenInput";


//# sourceMappingURL=ComboboxHiddenInput.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxOption/ComboboxOption.mjs
'use client';
















const ComboboxOption_defaultProps = {};
const ComboboxOption = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("ComboboxOption", ComboboxOption_defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    onClick,
    id,
    active,
    onMouseDown,
    onMouseOver,
    disabled,
    selected,
    mod,
    ...others
  } = props;
  const ctx = useComboboxContext();
  const uuid = (0,react.useId)();
  const _id = id || uuid;
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ...ctx.getStyles("option", { className, classNames, styles, style }),
      ...others,
      ref,
      id: _id,
      mod: [
        "combobox-option",
        { "combobox-active": active, "combobox-disabled": disabled, "combobox-selected": selected },
        mod
      ],
      role: "option",
      onClick: (event) => {
        if (!disabled) {
          ctx.onOptionSubmit?.(props.value, props);
          onClick?.(event);
        } else {
          event.preventDefault();
        }
      },
      onMouseDown: (event) => {
        event.preventDefault();
        onMouseDown?.(event);
      },
      onMouseOver: (event) => {
        if (ctx.resetSelectionOnOptionHover) {
          ctx.store.resetSelectedOption();
        }
        onMouseOver?.(event);
      }
    }
  );
});
ComboboxOption.classes = Combobox_module_css_classes;
ComboboxOption.displayName = "@mantine/core/ComboboxOption";


//# sourceMappingURL=ComboboxOption.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxOptions/ComboboxOptions.mjs
'use client';
















const ComboboxOptions_defaultProps = {};
const ComboboxOptions = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("ComboboxOptions", ComboboxOptions_defaultProps, _props);
  const { classNames, className, style, styles, id, onMouseDown, labelledBy, ...others } = props;
  const ctx = useComboboxContext();
  const _id = (0,use_id/* useId */.M)(id);
  (0,react.useEffect)(() => {
    ctx.store.setListId(_id);
  }, [_id]);
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ref,
      ...ctx.getStyles("options", { className, style, classNames, styles }),
      ...others,
      id: _id,
      role: "listbox",
      "aria-labelledby": labelledBy,
      onMouseDown: (event) => {
        event.preventDefault();
        onMouseDown?.(event);
      }
    }
  );
});
ComboboxOptions.classes = Combobox_module_css_classes;
ComboboxOptions.displayName = "@mantine/core/ComboboxOptions";


//# sourceMappingURL=ComboboxOptions.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Input/Input.mjs + 9 modules
var Input = __webpack_require__(85505);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxSearch/ComboboxSearch.mjs
'use client';


















const ComboboxSearch_defaultProps = {
  withAriaAttributes: true,
  withKeyboardNavigation: true
};
const ComboboxSearch = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("ComboboxSearch", ComboboxSearch_defaultProps, _props);
  const {
    classNames,
    styles,
    unstyled,
    vars,
    withAriaAttributes,
    onKeyDown,
    withKeyboardNavigation,
    size,
    ...others
  } = props;
  const ctx = useComboboxContext();
  const _styles = ctx.getStyles("search");
  const targetProps = useComboboxTargetProps({
    targetType: "input",
    withAriaAttributes,
    withKeyboardNavigation,
    withExpandedAttribute: false,
    onKeyDown,
    autoComplete: "off"
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Input/* Input */.I,
    {
      ref: (0,use_merged_ref/* useMergedRef */.Yx)(ref, ctx.store.searchRef),
      classNames: [{ input: _styles.className }, classNames],
      styles: [{ input: _styles.style }, styles],
      size: size || ctx.size,
      ...targetProps,
      ...others,
      __staticSelector: "Combobox"
    }
  );
});
ComboboxSearch.classes = Combobox_module_css_classes;
ComboboxSearch.displayName = "@mantine/core/ComboboxSearch";


//# sourceMappingURL=ComboboxSearch.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/ComboboxTarget/ComboboxTarget.mjs
'use client';




















const ComboboxTarget_defaultProps = {
  refProp: "ref",
  targetType: "input",
  withKeyboardNavigation: true,
  withAriaAttributes: true,
  withExpandedAttribute: false,
  autoComplete: "off"
};
const ComboboxTarget = (0,factory/* factory */.d)((props, ref) => {
  const {
    children,
    refProp,
    withKeyboardNavigation,
    withAriaAttributes,
    withExpandedAttribute,
    targetType,
    autoComplete,
    ...others
  } = (0,use_props/* useProps */.w)("ComboboxTarget", ComboboxTarget_defaultProps, props);
  if (!(0,is_element/* isElement */.k)(children)) {
    throw new Error(
      "Combobox.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  }
  const ctx = useComboboxContext();
  const targetProps = useComboboxTargetProps({
    targetType,
    withAriaAttributes,
    withKeyboardNavigation,
    withExpandedAttribute,
    onKeyDown: children.props.onKeyDown,
    autoComplete
  });
  const clonedElement = (0,react.cloneElement)(children, {
    ...targetProps,
    ...others
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(Popover.Target, { ref: (0,use_merged_ref/* useMergedRef */.Yx)(ref, ctx.store.targetRef), children: clonedElement });
});
ComboboxTarget.displayName = "@mantine/core/ComboboxTarget";


//# sourceMappingURL=ComboboxTarget.mjs.map

// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/use-combobox/use-combobox.mjs + 1 modules
var use_combobox = __webpack_require__(43630);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/Combobox.mjs
'use client';





































const Combobox_defaultProps = {
  keepMounted: true,
  withinPortal: true,
  resetSelectionOnOptionHover: false,
  width: "target",
  transitionProps: { transition: "fade", duration: 0 }
};
const Combobox_varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)((_, { size, dropdownPadding }) => ({
  options: {
    "--combobox-option-fz": (0,get_size/* getFontSize */.yv)(size),
    "--combobox-option-padding": (0,get_size/* getSize */.ap)(size, "combobox-option-padding")
  },
  dropdown: {
    "--combobox-padding": dropdownPadding === void 0 ? void 0 : (0,rem/* rem */.h)(dropdownPadding),
    "--combobox-option-fz": (0,get_size/* getFontSize */.yv)(size),
    "--combobox-option-padding": (0,get_size/* getSize */.ap)(size, "combobox-option-padding")
  }
}));
function Combobox(_props) {
  const props = (0,use_props/* useProps */.w)("Combobox", Combobox_defaultProps, _props);
  const {
    classNames,
    styles,
    unstyled,
    children,
    store: controlledStore,
    vars,
    onOptionSubmit,
    onClose,
    size,
    dropdownPadding,
    resetSelectionOnOptionHover,
    __staticSelector,
    readOnly,
    ...others
  } = props;
  const uncontrolledStore = (0,use_combobox/* useCombobox */.K)();
  const store = controlledStore || uncontrolledStore;
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: __staticSelector || "Combobox",
    classes: Combobox_module_css_classes,
    props,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver: Combobox_varsResolver
  });
  const onDropdownClose = () => {
    onClose?.();
    store.closeDropdown();
  };
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    ComboboxProvider,
    {
      value: {
        getStyles,
        store,
        onOptionSubmit,
        size,
        resetSelectionOnOptionHover,
        readOnly
      },
      children: /* @__PURE__ */ (0,jsx_runtime.jsx)(
        Popover,
        {
          opened: store.dropdownOpened,
          ...others,
          onClose: onDropdownClose,
          withRoles: false,
          unstyled,
          children
        }
      )
    }
  );
}
const extendCombobox = (c) => c;
Combobox.extend = extendCombobox;
Combobox.classes = Combobox_module_css_classes;
Combobox.displayName = "@mantine/core/Combobox";
Combobox.Target = ComboboxTarget;
Combobox.Dropdown = ComboboxDropdown;
Combobox.Options = ComboboxOptions;
Combobox.Option = ComboboxOption;
Combobox.Search = ComboboxSearch;
Combobox.Empty = ComboboxEmpty;
Combobox.Chevron = ComboboxChevron;
Combobox.Footer = ComboboxFooter;
Combobox.Header = ComboboxHeader;
Combobox.EventsTarget = ComboboxEventsTarget;
Combobox.DropdownTarget = ComboboxDropdownTarget;
Combobox.Group = ComboboxGroup;
Combobox.ClearButton = ComboboxClearButton;
Combobox.HiddenInput = ComboboxHiddenInput;


//# sourceMappingURL=Combobox.mjs.map


/***/ }),

/***/ 43630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ useCombobox; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.mjs
var use_uncontrolled = __webpack_require__(70464);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/use-combobox/get-index/get-index.mjs
'use client';
function getPreviousIndex(currentIndex, elements, loop) {
  for (let i = currentIndex - 1; i >= 0; i -= 1) {
    if (!elements[i].hasAttribute("data-combobox-disabled")) {
      return i;
    }
  }
  if (loop) {
    for (let i = elements.length - 1; i > -1; i -= 1) {
      if (!elements[i].hasAttribute("data-combobox-disabled")) {
        return i;
      }
    }
  }
  return currentIndex;
}
function getNextIndex(currentIndex, elements, loop) {
  for (let i = currentIndex + 1; i < elements.length; i += 1) {
    if (!elements[i].hasAttribute("data-combobox-disabled")) {
      return i;
    }
  }
  if (loop) {
    for (let i = 0; i < elements.length; i += 1) {
      if (!elements[i].hasAttribute("data-combobox-disabled")) {
        return i;
      }
    }
  }
  return currentIndex;
}
function getFirstIndex(elements) {
  for (let i = 0; i < elements.length; i += 1) {
    if (!elements[i].hasAttribute("data-combobox-disabled")) {
      return i;
    }
  }
  return -1;
}


//# sourceMappingURL=get-index.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Combobox/use-combobox/use-combobox.mjs
'use client';




function useCombobox({
  defaultOpened,
  opened,
  onOpenedChange,
  onDropdownClose,
  onDropdownOpen,
  loop = true,
  scrollBehavior = "instant"
} = {}) {
  const [dropdownOpened, setDropdownOpened] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: opened,
    defaultValue: defaultOpened,
    finalValue: false,
    onChange: onOpenedChange
  });
  const listId = (0,react.useRef)(null);
  const selectedOptionIndex = (0,react.useRef)(-1);
  const searchRef = (0,react.useRef)(null);
  const targetRef = (0,react.useRef)(null);
  const focusSearchTimeout = (0,react.useRef)(-1);
  const focusTargetTimeout = (0,react.useRef)(-1);
  const selectedIndexUpdateTimeout = (0,react.useRef)(-1);
  const openDropdown = (0,react.useCallback)(
    (eventSource = "unknown") => {
      if (!dropdownOpened) {
        setDropdownOpened(true);
        onDropdownOpen?.(eventSource);
      }
    },
    [setDropdownOpened, onDropdownOpen, dropdownOpened]
  );
  const closeDropdown = (0,react.useCallback)(
    (eventSource = "unknown") => {
      if (dropdownOpened) {
        setDropdownOpened(false);
        onDropdownClose?.(eventSource);
      }
    },
    [setDropdownOpened, onDropdownClose, dropdownOpened]
  );
  const toggleDropdown = (0,react.useCallback)(
    (eventSource = "unknown") => {
      if (dropdownOpened) {
        closeDropdown(eventSource);
      } else {
        openDropdown(eventSource);
      }
    },
    [closeDropdown, openDropdown, dropdownOpened]
  );
  const clearSelectedItem = (0,react.useCallback)(() => {
    const selected = document.querySelector(`#${listId.current} [data-combobox-selected]`);
    selected?.removeAttribute("data-combobox-selected");
    selected?.removeAttribute("aria-selected");
  }, []);
  const selectOption = (0,react.useCallback)(
    (index) => {
      const list = document.getElementById(listId.current);
      const items = list?.querySelectorAll("[data-combobox-option]");
      if (!items) {
        return null;
      }
      const nextIndex = index >= items.length ? 0 : index < 0 ? items.length - 1 : index;
      selectedOptionIndex.current = nextIndex;
      if (items?.[nextIndex] && !items[nextIndex].hasAttribute("data-combobox-disabled")) {
        clearSelectedItem();
        items[nextIndex].setAttribute("data-combobox-selected", "true");
        items[nextIndex].setAttribute("aria-selected", "true");
        items[nextIndex].scrollIntoView({ block: "nearest", behavior: scrollBehavior });
        return items[nextIndex].id;
      }
      return null;
    },
    [scrollBehavior, clearSelectedItem]
  );
  const selectActiveOption = (0,react.useCallback)(() => {
    const activeOption = document.querySelector(
      `#${listId.current} [data-combobox-active]`
    );
    if (activeOption) {
      const items = document.querySelectorAll(
        `#${listId.current} [data-combobox-option]`
      );
      const index = Array.from(items).findIndex((option) => option === activeOption);
      return selectOption(index);
    }
    return selectOption(0);
  }, [selectOption]);
  const selectNextOption = (0,react.useCallback)(
    () => selectOption(
      getNextIndex(
        selectedOptionIndex.current,
        document.querySelectorAll(`#${listId.current} [data-combobox-option]`),
        loop
      )
    ),
    [selectOption, loop]
  );
  const selectPreviousOption = (0,react.useCallback)(
    () => selectOption(
      getPreviousIndex(
        selectedOptionIndex.current,
        document.querySelectorAll(`#${listId.current} [data-combobox-option]`),
        loop
      )
    ),
    [selectOption, loop]
  );
  const selectFirstOption = (0,react.useCallback)(
    () => selectOption(
      getFirstIndex(
        document.querySelectorAll(`#${listId.current} [data-combobox-option]`)
      )
    ),
    [selectOption]
  );
  const updateSelectedOptionIndex = (0,react.useCallback)(
    (target = "selected", options) => {
      selectedIndexUpdateTimeout.current = window.setTimeout(() => {
        const items = document.querySelectorAll(
          `#${listId.current} [data-combobox-option]`
        );
        const index = Array.from(items).findIndex(
          (option) => option.hasAttribute(`data-combobox-${target}`)
        );
        selectedOptionIndex.current = index;
        if (options?.scrollIntoView) {
          items[index]?.scrollIntoView({ block: "nearest", behavior: scrollBehavior });
        }
      }, 0);
    },
    []
  );
  const resetSelectedOption = (0,react.useCallback)(() => {
    selectedOptionIndex.current = -1;
    clearSelectedItem();
  }, [clearSelectedItem]);
  const clickSelectedOption = (0,react.useCallback)(() => {
    const items = document.querySelectorAll(
      `#${listId.current} [data-combobox-option]`
    );
    const item = items?.[selectedOptionIndex.current];
    item?.click();
  }, []);
  const setListId = (0,react.useCallback)((id) => {
    listId.current = id;
  }, []);
  const focusSearchInput = (0,react.useCallback)(() => {
    focusSearchTimeout.current = window.setTimeout(() => searchRef.current.focus(), 0);
  }, []);
  const focusTarget = (0,react.useCallback)(() => {
    focusTargetTimeout.current = window.setTimeout(() => targetRef.current.focus(), 0);
  }, []);
  const getSelectedOptionIndex = (0,react.useCallback)(() => selectedOptionIndex.current, []);
  (0,react.useEffect)(
    () => () => {
      window.clearTimeout(focusSearchTimeout.current);
      window.clearTimeout(focusTargetTimeout.current);
      window.clearTimeout(selectedIndexUpdateTimeout.current);
    },
    []
  );
  return {
    dropdownOpened,
    openDropdown,
    closeDropdown,
    toggleDropdown,
    selectedOptionIndex: selectedOptionIndex.current,
    getSelectedOptionIndex,
    selectOption,
    selectFirstOption,
    selectActiveOption,
    selectNextOption,
    selectPreviousOption,
    resetSelectedOption,
    updateSelectedOptionIndex,
    listId: listId.current,
    setListId,
    clickSelectedOption,
    searchRef,
    focusSearchInput,
    targetRef,
    focusTarget
  };
}


//# sourceMappingURL=use-combobox.mjs.map


/***/ }),

/***/ 82696:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Group; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/utils/get-size/get-size.mjs
var get_size = __webpack_require__(32825);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/styles-api/create-vars-resolver/create-vars-resolver.mjs
var create_vars_resolver = __webpack_require__(79346);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/MantineProvider/use-props/use-props.mjs
var use_props = __webpack_require__(57285);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/styles-api/use-styles/use-styles.mjs + 17 modules
var use_styles = __webpack_require__(21413);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/Box/Box.mjs + 21 modules
var Box = __webpack_require__(46293);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/factory/factory.mjs
var factory = __webpack_require__(21774);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Group/filter-falsy-children/filter-falsy-children.mjs
'use client';


function filterFalsyChildren(children) {
  return react.Children.toArray(children).filter(Boolean);
}


//# sourceMappingURL=filter-falsy-children.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Group/Group.module.css.mjs
'use client';
var classes = {"root":"m_4081bf90"};


//# sourceMappingURL=Group.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/Group/Group.mjs
'use client';



















const defaultProps = {
  preventGrowOverflow: true,
  gap: "md",
  align: "center",
  justify: "flex-start",
  wrap: "wrap"
};
const varsResolver = (0,create_vars_resolver/* createVarsResolver */.Z)(
  (_, { grow, preventGrowOverflow, gap, align, justify, wrap }, { childWidth }) => ({
    root: {
      "--group-child-width": grow && preventGrowOverflow ? childWidth : void 0,
      "--group-gap": (0,get_size/* getSpacing */.bG)(gap),
      "--group-align": align,
      "--group-justify": justify,
      "--group-wrap": wrap
    }
  })
);
const Group = (0,factory/* factory */.d)((_props, ref) => {
  const props = (0,use_props/* useProps */.w)("Group", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    children,
    gap,
    align,
    justify,
    wrap,
    grow,
    preventGrowOverflow,
    vars,
    variant,
    __size,
    mod,
    ...others
  } = props;
  const filteredChildren = filterFalsyChildren(children);
  const childrenCount = filteredChildren.length;
  const resolvedGap = (0,get_size/* getSpacing */.bG)(gap ?? "md");
  const childWidth = `calc(${100 / childrenCount}% - (${resolvedGap} - ${resolvedGap} / ${childrenCount}))`;
  const stylesCtx = { childWidth };
  const getStyles = (0,use_styles/* useStyles */.y)({
    name: "Group",
    props,
    stylesCtx,
    className,
    style,
    classes: classes,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */ (0,jsx_runtime.jsx)(
    Box/* Box */.x,
    {
      ...getStyles("root"),
      ref,
      variant,
      mod: [{ grow }, mod],
      size: __size,
      ...others,
      children: filteredChildren
    }
  );
});
Group.classes = classes;
Group.displayName = "@mantine/core/Group";


//# sourceMappingURL=Group.mjs.map


/***/ }),

/***/ 77804:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ UnstyledButton; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/MantineProvider/use-props/use-props.mjs
var use_props = __webpack_require__(57285);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/styles-api/use-styles/use-styles.mjs + 17 modules
var use_styles = __webpack_require__(21413);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/Box/Box.mjs + 21 modules
var Box = __webpack_require__(46293);
// EXTERNAL MODULE: ../../node_modules/@mantine/core/esm/core/factory/polymorphic-factory.mjs
var polymorphic_factory = __webpack_require__(10046);
;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/UnstyledButton/UnstyledButton.module.css.mjs
'use client';
var classes = {"root":"m_87cf2631"};


//# sourceMappingURL=UnstyledButton.module.css.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@mantine/core/esm/components/UnstyledButton/UnstyledButton.mjs
'use client';
















const defaultProps = {
  __staticSelector: "UnstyledButton"
};
const UnstyledButton = (0,polymorphic_factory/* polymorphicFactory */.b)(
  (_props, ref) => {
    const props = (0,use_props/* useProps */.w)("UnstyledButton", defaultProps, _props);
    const {
      className,
      component = "button",
      __staticSelector,
      unstyled,
      classNames,
      styles,
      style,
      ...others
    } = props;
    const getStyles = (0,use_styles/* useStyles */.y)({
      name: __staticSelector,
      props,
      classes: classes,
      className,
      style,
      classNames,
      styles,
      unstyled
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(
      Box/* Box */.x,
      {
        ...getStyles("root", { focusable: true }),
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        ...others
      }
    );
  }
);
UnstyledButton.classes = classes;
UnstyledButton.displayName = "@mantine/core/UnstyledButton";


//# sourceMappingURL=UnstyledButton.mjs.map


/***/ }),

/***/ 70464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useUncontrolled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
'use client';


function useUncontrolled({
  value,
  defaultValue,
  finalValue,
  onChange = () => {
  }
}) {
  const [uncontrolledValue, setUncontrolledValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(
    defaultValue !== void 0 ? defaultValue : finalValue
  );
  const handleUncontrolledChange = (val, ...payload) => {
    setUncontrolledValue(val);
    onChange?.(val, ...payload);
  };
  if (value !== void 0) {
    return [value, onChange, true];
  }
  return [uncontrolledValue, handleUncontrolledChange, false];
}


//# sourceMappingURL=use-uncontrolled.mjs.map


/***/ })

}]);